import axios from 'axios';

import { useServicerStore } from '../store';

const PaymentService = {
  async getPayments({ page, limit }) {
    const response = await axios.get('/payment', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async createPayment({ formValues, loanId }) {
    const response = await axios.post('/payment', {
      ...formValues,
      loan_id: loanId,
    });

    return response.data;
  },

  async getPayment(paymentId) {
    const response = await axios.get(`/payment/${paymentId}`);

    return response.data;
  },

  async getPaymentPlan({
    paymentId,
    // allowPartialOnInvoice,
    // allowPartialOnLineItem,
    //  applyExtraPaymentToPrincipal,
    // includeScheduled,
    skipLineItems = [],
  }) {
    const response = await axios.get(`/payment/${paymentId}/plan`, {
      params: {
        // allow_partial_on_invoice: allowPartialOnInvoice,
        //  allow_partial_on_line_item: allowPartialOnLineItem,
        //  apply_extra_payment_to_principal: applyExtraPaymentToPrincipal,
        //   include_scheduled: includeScheduled,
        skip_line_items: skipLineItems,
      },
    });

    return response.data;
  },

  async distributePayment({ paymentId, skipLineItems = [] }) {
    const response = await axios.post(`/payment/${paymentId}/distribute`, {
      skip_line_items: skipLineItems,
    });

    return response.data;
  },

  async updatePayment({ paymentId, formValues }) {
    const response = await axios.patch(`/payment/${paymentId}`, formValues);

    return response.data;
  },

  async reversePayment({ paymentId, formValues }) {
    const response = await axios.patch(
      `/payment/${paymentId}/reverse`,
      formValues
    );

    return response.data;
  },

  async deletePayment(paymentId) {
    const response = await axios.delete(`/payment/${paymentId}`);

    return response.data;
  },

  async refundUnapplied(paymentId) {
    const response = await axios.post(`/payment/${paymentId}/refund_unapplied`);

    return response.data;
  },
};

export default PaymentService;
